import styled from 'styled-components'

export const ItemContainer = styled.div`
	& h4 {
		font-weight: 500;
	}
`
